export default __webpack_public_path__ + "static/media/element_2.3170ffa9.webp";